import {
    FETCH_INVITATIONS,
    FETCH_INVITATIONS_SUCCESS,
    FETCH_INVITATIONS_FAIL,
    ACCEPT_INVITATION,
    ACCEPT_INVITATION_SUCCESS,
    ACCEPT_INVITATION_FAIL,
    REJECT_INVITATION,
    REJECT_INVITATION_SUCCESS,
    REJECT_INVITATION_FAIL,
  } from "../actions/InvitationsActions";
  
  const initialState = {
    isLoading: false,
    invitations: [],
    error: null,
  };
  
  const invitationsReducer = (state = initialState, { type, payload }) => {
    switch (type) {
      case FETCH_INVITATIONS:
        return {
            ...state,
            isLoading: true,
          };
      case FETCH_INVITATIONS_FAIL:
        return {
            ...state,
            isLoading: false,
            error: payload.error,
          };
      case FETCH_INVITATIONS_SUCCESS:
        return {
          ...state,
          isLoading: false,
          invitations: payload.data || [],
        };
  

      case ACCEPT_INVITATION:
        return {
            ...state,
            isLoading: true,
        };
      case ACCEPT_INVITATION_SUCCESS:
        return {
            ...state,
            isLoading: false,
        };
      case ACCEPT_INVITATION_FAIL:
        return {
            ...state,
            isLoading: false,
            error: payload.error,
        };



        
      case REJECT_INVITATION:
        return {
            ...state,
            isLoading: true,
        };
      case REJECT_INVITATION_FAIL:
        return {
            ...state,
            isLoading: false,
            error: payload.error,
        };
    case REJECT_INVITATION_SUCCESS:
        return {
            ...state,
            isLoading: false,
        };

      default:
        return state;
    }
  };
  
  export default invitationsReducer;
  